import clsx from 'clsx'
import React from 'react'
import {KTSVG} from '../../../helpers'

type Props = {
  title?: string
  loading?: any
  className?: string
  icon?: any
  list: any
  menuLeftOrRight?: 'start' | 'end'
  value?: any
}

const DropdownButton: React.FC<Props> = React.memo(
  ({title, className = '', menuLeftOrRight = 'end', icon, list, loading, value}) => {
    const renderIcon = () => {
      if (loading) {
        return <div className='ms-2 spinner-border spinner-border-sm' role='status' />
      } else if (icon) {
        return icon
      } else {
        return (
          <KTSVG
            path='/media/gori/claims/three-dots.svg'
            small={false}
            className='rounded-circle bg-hover-light p-1'
          />
        )
      }
    }

    const handleList = list.filter((data) => {
      return !data.hidden
    })

    return (
      <>
        <div
          className={clsx('d-flex justify-content-end align-items-center', className, {
            'pe-none': handleList.length === 0,
          })}
          data-bs-toggle='dropdown'
          aria-expanded='false'
        >
          {title}
          {renderIcon()}
        </div>
        <div
          className={clsx('dropdown-menu fw-bold fs-7 py-2', {
            [`dropdown-menu-lg-${menuLeftOrRight}`]: menuLeftOrRight,
          })}
        >
          {handleList.length > 0 &&
            handleList.map((child: any, index: number) => {
              return (
                <div
                  className={clsx(`dropdown-item my-1 cursor-pointer fw-bold`, child?.className, {
                    'bg-primary text-white': child.value && value === child.value,
                    'text-gray-600 bg-hover-light-primary': child.value && value !== child.value,
                  })}
                  key={index}
                  onClick={child?.action}
                >
                  {child?.label && <span className='menu-link'>{child.label}</span>}
                  {child?.children && <div>{child.children}</div>}
                </div>
              )
            })}
        </div>
      </>
    )
  }
)
DropdownButton.displayName = 'DropdownButton'

export {DropdownButton}
